import { render, staticRenderFns } from "./ExpensesReportTable.vue?vue&type=template&id=5819cdc8&"
import script from "./ExpensesReportTable.vue?vue&type=script&lang=ts&"
export * from "./ExpensesReportTable.vue?vue&type=script&lang=ts&"
import style0 from "./ExpensesReportTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports